import styled, { css } from 'styled-components';

import colors from '../../../styles/theme/colors';
import { radii } from '../styles/scales';
import { spin } from '../Button/constants';

const { gray, green } = colors.designSystem;

const tamanhos = {
  sm: css`
    height: 16px;
    width: 16px;
    border-width: 2px;
  `,
  md: css`
    height: 32px;
    width: 32px;
    border-width: 4px;
  `,
};

export const StyledSpinner = styled.span<{ $tamanho: 'sm' | 'md' }>`
  display: inline-block;
  border-radius: ${radii.full};
  border-style: solid;
  border-color: ${gray[200]};
  border-top-color: ${green[500]};
  animation: ${spin} 700ms linear infinite;

  ${({ $tamanho }) => tamanhos[$tamanho]}
`;
